"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _Typography = _interopRequireDefault(require("../Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  flex-grow: 1;\n  cursor: pointer;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  margin: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: #888888;\n  cursor: pointer;\n  font-size: 20px;\n  margin: 4px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIcon = (0, _styledComponents["default"])(_reactFontawesome.FontAwesomeIcon)(_templateObject());

var RadioRoot = _styledComponents["default"].div(_templateObject2());

var RadioControl = _styledComponents["default"].div(_templateObject3());

var RadioLabel = _styledComponents["default"].div(_templateObject4());

var Radio = function Radio(_ref) {
  var value = _ref.value,
      checked = _ref.checked,
      props = _objectWithoutProperties(_ref, ["value", "checked"]);

  return /*#__PURE__*/_react["default"].createElement(RadioRoot, null, /*#__PURE__*/_react["default"].createElement(RadioControl, {
    onClick: props.onClick
  }, !checked && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    icon: _freeRegularSvgIcons.faCircle,
    onClick: props.onClick
  }), checked && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    icon: _freeSolidSvgIcons.faDotCircle
  })), /*#__PURE__*/_react["default"].createElement(RadioLabel, {
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "span"
  }, props.label)));
};

Radio.propTypes = {
  /**
   * Radio group name
   */
  label: _propTypes["default"].any,

  /**
   * Radio value
   */
  value: _propTypes["default"].any,

  /**
   * Is it checked / selected
   */
  checked: _propTypes["default"].bool
};
var _default = Radio;
exports["default"] = _default;